
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fleetportal",
      function () {
        return require("private-next-pages/fleetportal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fleetportal"])
      });
    }
  